export const logoSpecificSize = {
  sizeInPx: {
    rollins: '120px',
  },
};
